import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage' 
import { AppStateProvider } from './state/AppProvider'
import ContactForm from '../../frontend/src/components/ContactForm'
import './index.css'

initializeIcons()

export default function App() {
 /* let email: Email

  email = {

    sender_email:"johndoe@gmail.com",
    name: "John D",
    membership_status: "NONE",
    message: "hello there",
    chat_id: "3333", 

} */

//submit_email(email)


  return (
    <AppStateProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Chat />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </HashRouter>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
)

